module.exports = __webpack_public_path__ + "assets/img/sdwan-module9-2.08e72ace.jpg";